// extracted by mini-css-extract-plugin
export default {"closeButton":"styles_closeButton__fPEFk","blue":"styles_blue__nwB2e","content":"styles_content__xYJcq","green":"styles_green__wZf7c","icon":"styles_icon__2g3bo"};